import Logger, { LoggerOptions } from "./Logger";
import Logging from "./Logging";

export default Logging;
export { Logger };
export type { LoggerOptions };
export * from "./loggers";
export * from "./LogTypes";
